<script>
import { Line } from "vue-chartjs";

export default {
  extends: Line,
  mounted() {
    this.renderChart(
      {
        labels: [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December"
        ],
        datasets: [
          {
            label: "Demand Forecast",
            data: [7, 10, 67, 9, 50, 6, 30,7,2,89,90,87],
            backgroundColor: "transparent",
            borderColor: "rgba(1, 116, 188)",
            pointBackgroundColor: "rgba(171, 71, 188, 1)"
          },
          
        ]
      },
      {
        responsive: true,
        maintainAspectRatio: false,
        title: {
          display: true,
          text: "Summary Data"
        }
      }
    );
  }
};
</script>